.switchComponentContainer {
	margin-top: 50px;
	width: 100%;
}

.switchComponentFieldLabel {
	margin-left: 30px;
}
